(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.online.payment', {
            parent: 'public.online',
            url: '/payment',
            data: {
                authorities: [],
                bodyClass: " transparent-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.online.payment': {
                    templateUrl: 'app/public/online/payment/payment.html',
                    controller: 'OnlinePaymentReservationController',
                    controllerAs: 'vm'
                },
                'navbar@public.online.payment': {},
                'topnavbar@public.online.payment': {}
            },
            params: {
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
